import React from 'react'
import { DateFormat, CurrencyFormat, PercentFormat, formatApr } from '../../../../helpers/formatting'

export default function CollectionRefinanceSchedule({
  scheduleData,
  setCurrentStep,
  sendCollectionRefinanceForSignature,
  isSendingForSignature,
  cancelCollectionRefinance,
}) {
  if (!scheduleData) return (
    <div className="column"></div>
  );
  return (
    <div className="column">
      <div className="columns mb-0 is-flex-direction-column">
        <div className="column">
          <div className="columns is-multiline">
            <div className="column is-half">
              <p><strong>Total Amount:</strong> <CurrencyFormat value={scheduleData?.total_amount} />
              </p>
              <p><strong>Total Interest:</strong> <CurrencyFormat
                value={scheduleData?.total_interest}
              /></p>
              <p><strong>Loan Due Date:</strong> <DateFormat dateString={scheduleData?.loan_due_date} />
              </p>
            </div>
            <div className="column is-half">
              <p><strong>Effective Date:</strong> <DateFormat
                dateString={scheduleData?.effective_date}
              /></p>
              <p><strong>APR:</strong> {formatApr(scheduleData?.apr)}%</p>
              <p><strong>Interest Rate:</strong> <PercentFormat value={scheduleData?.interest_rate} /></p>
            </div>
          </div>
          <div className="table-container">
            <table className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth is-grey mb-3">
              <thead>
                <tr>
                  <th colSpan="5" className="is-selected has-text-left lox-payment-schedule-color">Payment Schedule</th>
                </tr>
                <tr>
                  <th className="is-selected has-text-centered lox-payment-schedule-color">
                    #
                  </th>
                  <th className="is-selected has-text-centered lox-payment-schedule-color">
                    Date
                  </th>
                  <th className="is-selected has-text-centered lox-payment-schedule-color">
                    Principal $
                  </th>
                  <th className="is-selected has-text-centered lox-payment-schedule-color">
                    Interest $
                  </th>
                  <th className="is-selected has-text-centered lox-payment-schedule-color">
                    Total $$$
                  </th>
                </tr>
              </thead>
              <tbody>
                {scheduleData?.schedule?.map((item, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <tr key={index}>
                    <td className="has-text-centered" style={{ whiteSpace: 'nowrap' }}>{index + 1}</td>
                    <td
                      className="has-text-left"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <DateFormat dateString={item.date} />
                    </td>
                    <td
                      className="has-text-left"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <CurrencyFormat value={+item.principal_amount} />
                    </td>
                    <td
                      className="has-text-left"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <CurrencyFormat value={+item.payment - +item.principal_amount} />
                    </td>
                    <td
                      className="has-text-left"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <CurrencyFormat value={+item.payment} />
                    </td>
                  </tr>
                ))}
              </tbody>
              <thead>
                <tr>
                  <th colSpan="2" className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>TOTAL PLAN</th>
                  <th className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>
                    <CurrencyFormat value={scheduleData?.schedule?.reduce((total, item) => total + +item.principal_amount, 0)} />
                  </th>
                  <th className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>
                    <CurrencyFormat value={scheduleData?.schedule?.reduce((total, item) => total + (+item.payment - +item.principal_amount), 0)} />
                  </th>
                  <th className="is-selected has-text-centered" style={{ backgroundColor: "#7F7F7F" }}>
                    <CurrencyFormat value={scheduleData?.schedule?.reduce((total, item) => total + +item.payment, 0)} />
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div className="lox-form__buttons-wrapper has-text-right">
            <button
              type="button"
              className="button is-light is-small mr-2"
              onClick={async (e) => {
                cancelCollectionRefinance();
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="button is-link is-small px-2"
              onClick={async (e) => {
                sendCollectionRefinanceForSignature(e);
              }}
              disabled={isSendingForSignature}
            >
              {isSendingForSignature ? 'Sending...' : 'Send For Signature'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
